export default "__VITE_ASSET__Ciuofo0H__"